import cookie from 'cookie';

export const getCookie = name => {
  if (typeof window !== 'undefined') {
    return cookie.parse(document?.cookie || '')[name] || null;
  }

  return null;
};
